import { useEffect, useRef, useState } from "react";
import {
  Constants,
    MeetingProvider,
    useMeeting
} from "@videosdk.live/react-sdk";
import { useParams } from "react-router-dom";

import { authToken, createMeeting } from "../page_components/videocall/API";
import { printContent } from '../utils/printUtils';


// CSS
import '../styles/videoconference.css'
import '../styles/animation.css'


// HOOKS
import useFetch from "../hooks/useFetch";
import useSendPushNotification from "../hooks/useSendPushNotification";



// ICONS
import ParticipantGrid from "../page_components/videocall_new/ParticipantGrid";

// 3RD PARTY
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import html2pdf from 'html2pdf.js';

import Tooltip from '@mui/material/Tooltip';

import { useAuth } from '../contexts/AuthContext';

import Swal from "sweetalert2";


// S3 VIDEO RECORDING UPLOAD
import { S3Client, PutObjectCommand,GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
// import fetch from "node-fetch";
import axios from "axios";
import useCachedTransactions from "../hooks/useFetchWithCache";
import apiRequest from "../services/apiService";
import LoadingAnimation from "../components/Loading";
import NotaryAcknowledgmentForVirtual from "../page_components/notary/crud/addwizard/NotaryAcknowledgmentForVirtual";
import BackdropModal from "../components/modals/backdrop_modal";
import BackdropModalSmall from "../components/modals/backdrop_modal_small";
import useSendEmail from "../hooks/useSendEmail";
import useUpdate from "../hooks/useUpdate";


// GRAPHQL
import useModelData from "../hooks/useModelData";
import { generateClient } from "aws-amplify/api";

import { updateTransaction, updateWitnessTransaction } from "../graphql/mutations";
import { onUpdateTransaction, onUpdateWitnessTransaction } from "../graphql/subscriptions";
import { listWitnessTransaction } from "../graphql/queries";
import PreCallSetup from "./TestPreCallSetup";




const region          = process.env.REACT_APP_AWS_S3_REGION_NAME;
const bucket          = process.env.REACT_APP_AWS_STORAGE_BUCKET_NAME;
const accessKeyId     = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
const expiresIn       = process.env.REACT_APP_URL_EXPIRY_IN_SECONDS;
const videoSDKToken   = process.env.REACT_APP_VIDEOSDK_TOKEN;


const s3Client = new S3Client({
  credentials: {
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
  },
  region: region,
});

const createPresignedUrlWithClient = async (key) => {
   const command = new PutObjectCommand({ Bucket: bucket, Key: key }); //-> FOR UPLOADING FILE IN S3. IT DOESNT ADD EXPIRATION
  //const command = new GetObjectCommand({ Bucket: bucket, Key: key, }); //-> this code is to create an expiration to the file


  const preSignedUrl = await getSignedUrl(s3Client, command, { expiresIn: expiresIn });
 
  console.log("Pre-signed URL: ", preSignedUrl);
  return preSignedUrl;
};

const createPresignedUrlForExpirationOfFileWithClient = async (key) => {
   const command = new PutObjectCommand({ Bucket: bucket, Key: key }); //-> FOR UPLOADING FILE IN S3. IT DOESNT ADD EXPIRATION
  //const command = new GetObjectCommand({ Bucket: bucket, Key: key, }); //-> this code is to create an expiration to the file


  const preSignedUrl = await getSignedUrl(s3Client, command, { expiresIn: expiresIn });
 
  console.log("Pre-signed URL: ", preSignedUrl);
  return preSignedUrl;
};



function onRecordingStateChanged(data,setBlinking) {
  const { status } = data;

  if (status === Constants.recordingEvents.RECORDING_STARTING) {
    toast.info("Meeting recording is starting");
  } else if (status === Constants.recordingEvents.RECORDING_STARTED) {
    toast.success("Meeting recording is started");
    setBlinking(true);
  } else if (status === Constants.recordingEvents.RECORDING_STOPPING) {
    toast.warning("Meeting recording is stopping");
  } else if (status === Constants.recordingEvents.RECORDING_STOPPED) {
    toast.info("Meeting recording is stopped");
    setBlinking(false);
  } else {
    toast.error("Unknown recording state");
  }
}

function Controls({participantIds,formData,setFormData}) {

  const { sendPushNotification, response, error } = useSendPushNotification();


  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [successStatus, setSuccessStatus] = useState("")


  const { user } = useAuth();
  const { mid, id, apitransactionid } = useParams();

  const lawyerId           = user.user_id;
  const lawyerProfilePhoto = user.user_profile_photo
  const lawyerSignature    = user.signature

  
 console.log("user",user);


  const { sendEmail, responseEmail, errorEmail } = useSendEmail();
  const { updateData, isLoading:isLoadingUpdate, errorMessage:errorMessageUpdate, successMessage:successMessageUpdate, responseData:responseDataUpdate } = useUpdate('patch');


  
  // UPDATE GRAPQHL
  const { updateItem } = useModelData({
      model: "Transaction",
      queries: {
        update: updateTransaction,
      },
      subscriptions: {
        onUpdate: onUpdateTransaction,
      }
    });
  
  
  const [isFromURL,setIsfromUrl] = useState("no");
      useEffect(() => {

        console.log(formData,"gg");

          const value = formData.lawyerImage;

        if (typeof value === "string") {
          if (value.startsWith("data:image/")) {
            setIsfromUrl("no"); // It's base64
          } else if (value.startsWith("http://") || value.startsWith("https://")) {
            setIsfromUrl("yes"); // It's a URL
          } else {
            setIsfromUrl("no");
          }
        } else if (value instanceof File) {
          setIsfromUrl("no"); // It's a file object
        } else {
          setIsfromUrl("no"); // Unknown format
        }

    
      }, [formData.lawyerImage]);


    
      
  const [countdownClosing, setCountdownClosing] = useState(3);
  const [transactionEnded, setTransactionEnded] = useState(false);

  useEffect(() => {
    let interval;

    if (successStatus === "success" && !transactionEnded) {
      // Start countdown
      interval = setInterval(() => {
        setCountdownClosing(prev => {
          if (prev === 1) {
            clearInterval(interval);
            setTransactionEnded(true); // prevent retrigger
            handleEndTransaction();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [successStatus, transactionEnded]);
      



  // const handleProcessingCertificate = async () => {
  //   const updateInput = {
  //     id: id,
  //     transaction_status: "RELEASED",
  //   };
  //   await updateItem(updateInput);
  // };

  function base64ToFile(base64, filename = 'image.jpg') {
              const arr = base64.split(',');
              const mime = arr[0].match(/:(.*?);/)[1];
              const bstr = atob(arr[1]);
              let n = bstr.length;
              const u8arr = new Uint8Array(n);
          
              while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
              }
          
              return new File([u8arr], filename, { type: mime });
          }
          

  const sendToEmail = async () => {

    if(!formData.bookNo ||!formData.documentNo ||!formData.pageNo){
        setOpenOtherDetails(true);
      return;
    }

     Swal.fire({
          title: 'Release Document',
          text: 'Do you want to continue? \n once released it cannot be editable.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'btn btn-danger',
          cancelButtonColor: 'btn btn-secondary',
          confirmButtonText: 'Yes!',
          cancelButtonText: 'No, cancel',
          confirmButtonColor: '#03c3ec',
          cancelButtonColor: '#ff3e1d',
        }).then((result) => {
          if (result.isConfirmed) {

              previousScale.current = scale;

              setScale(1);

 
              triggerBulkUpdateByTransactionId();
              setIsSubmitting(true);
              stopRecording();


              try {

                  const storageKey = `witnesses_image_${id}`;
                  const storedWitnesses = JSON.parse(localStorage.getItem(storageKey) || '[]');


                  const url = `${process.env.REACT_APP_API_URL}/transactions/generate_pdf_and_update/`;
                  const payload = new FormData();


                  const lawyerPhoto     = localStorage.getItem(`notary_image_${id}`);
                  const compressedBase64_lawyerPhoto = base64ToFile(lawyerPhoto, 'lawyer_profile_photo.jpg');



                  payload.append("document_id", formData.transactionId);
                  payload.append("released_by_id", lawyerId);
                  payload.append("recipient_email", formData.email);
                  payload.append("second_party_recipient_email", formData.secondPartyEmail);

                  payload.append("document_no", formData.documentNo);
                  payload.append("page_no", formData.pageNo);
                  payload.append("book_no", formData.bookNo);
                  payload.append("video_url", finalVideoUrl);
                  payload.append("video_url_expiration", finalVideoUrlWithExpiration);

                  

                  payload.append("principalFirstName", formData.firstName?.toUpperCase());
                  payload.append("principalMiddleName", formData.middleName?.toUpperCase() || "");
                  payload.append("principalLastName", formData.lastName?.toUpperCase());
                  payload.append("principalSuffix", formData.suffix?.toUpperCase() || "");

                  payload.append("principalImage", formData.principalImage);
                  payload.append("principalImageSignature", formData.principalImageSignature);
                  payload.append("principalImageGovernmentId", formData.governmentId);
                  payload.append("principalImageIdType", formData.idType);
                  payload.append("principalImageIdNo", formData.idNo);
                  payload.append("principalImageDateIssued", formData.dateIssued || "");

               

                  payload.append("secondPartyPrincipalImage", formData.secondPartyPrincipalImage || "");
                  payload.append("secondPartyPrincipalImageSignature", formData.secondPartyPrincipalImageSignature || "");
                  payload.append("secondPartyFirstName", formData.secondPartyFirstName?.toUpperCase() || "");
                  payload.append("secondPartyMiddleName", formData.secondPartyMiddleName?.toUpperCase() || "");
                  payload.append("secondPartyLastName", formData.secondPartyLastName?.toUpperCase() || "");
                  payload.append("secondPartySuffix", formData.secondPartySuffix?.toUpperCase() || "");
                  payload.append("secondPartyGovernmentId", formData.secondPartyGovernmentId || "");
                  payload.append("secondPartyIdType", formData.secondPartyIdType || "");
                  payload.append("secondPartyIdNo", formData.secondPartyIdNo || "");
                  payload.append("secondPartyDateIssued", formData.secondPartyDateIssued || "");

         

                  payload.append("qr", formData.qr);



                  //payload.append("witnesses", JSON.stringify(formData.witnesses));
                  payload.append("witnesses", JSON.stringify(storedWitnesses));

                  //PDF PASSWORD
                  payload.append("pdf_pass", mid);


                  // payload.append("lawyer_profile_photo", formData.lawyerImage);
                  payload.append("lawyer_profile_photo", compressedBase64_lawyerPhoto);
                  payload.append("lawyer_profile_photo_is_link", isFromURL);
                  payload.append("lawyer_profile_photo_link", lawyerProfilePhoto);


                  payload.append("lawyer_firstname", user.first_name?.toUpperCase());
                  payload.append("lawyer_middle_name", user.middle_name?.toUpperCase() || "");
                  payload.append("lawyer_last_name", user.last_name?.toUpperCase());
                  payload.append("lawyer_suffix_name", user.suffix_name?.toUpperCase() || "");

                  payload.append("lawyer_signature", user.signature);

                  payload.append("lawyer_enp_roll_no", user.enp_roll_no);
                  payload.append("lawyer_enp_commission_no", user.enp_commission_no);
                  payload.append("lawyer_enp_commission_expiry_date", user.enp_commission_expiry_date);
                  payload.append("lawyer_enp_ptr_no", user.enp_ptr_no);
                  payload.append("lawyer_enp_ptr_issued_place", user.enp_ptr_issued_place);
                  payload.append("lawyer_enp_ptr_issued_date", user.enp_ptr_issued_date);
                  payload.append("lawyer_enp_ibp_no", user.enp_ibp_no);
                  payload.append("lawyer_enp_address", user.enp_address);
                  payload.append("lawyer_enp_compliance_no", user.enp_compliance_no);
                  payload.append("lawyer_enp_compliance_issued_date", user.enp_compliance_issued_date);
                  payload.append("lawyer_enp_notary_name", user.enp_notary_name);
                  payload.append("lawyer_enp_email", user.enp_email);

 



                  updateData(url, payload, (responseData) => {
                    console.log("Server PDF URL:", responseData.pdf_url);

                    
                    if (responseData?.pdf_url) {
                      setSuccessStatus(responseData.status);
                      handleReleaseCertificate();
                      setOpen(true);
                    }

                    setTimeout(() => {
                      setScale(previousScale.current);
                    }, 300);


                  });

                } catch (err) {
                  console.error("Server PDF failure:", err);
                  setIsSubmitting(false);
                }

              


                 /* OLD GENERATE PDF, NOW CHANGE TO BACKEND GENERATE PDF
                 
                 try {
                    const element = printableAcknowledgementForVirtual.current;
                
                    // Configure html2pdf options
                    const options = {
                      margin:       0,
                      filename:     `${formData.transactionId}.pdf`,
                      image:        { type: 'jpg', quality: 1 },

                      // PAG 1.05 may black pa na kulay sa print
                      // html2canvas:  { scale: 1.05 },
                      // jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
                      html2canvas:  { scale: 1.5 },
                      jsPDF:        { unit: 'mm', format: [210, 320], orientation: 'portrait' } // Custom size: [width, height] in mm
                    };
                
                    // Generate PDF using html2pdf.js
                    html2pdf()
                      .from(element) // From the printable element
                      .set(options)  // Set options
                      .toPdf()
                      .get('pdf')
                      .then(function(pdf) {
                        // Convert the PDF to a Blob
                        const pdfBlob = pdf.output('blob');
                
                        // Create a FormData object to send via API
                        const formDataEmail = new FormData();
                        formDataEmail.append('pdf', pdfBlob, `${formData.transactionId}.pdf`);
                        formDataEmail.append('document_id', formData.transactionId);
                        formDataEmail.append('released_by_id', lawyerId);
                        formDataEmail.append('recipient_email', formData.email);
                        formDataEmail.append('second_party_recipient_email', formData.secondPartyEmail);


                        formDataEmail.append('document_no', formData.documentNo);
                        formDataEmail.append('page_no', formData.pageNo);
                        formDataEmail.append('book_no', formData.bookNo);

                        formDataEmail.append('video_url', finalVideoUrl);



                        


                        formDataEmail.append('lawyer_profile_photo', formData.lawyerImage);
                        formDataEmail.append('lawyer_profile_photo_is_link', isFromURL);
                        formDataEmail.append('lawyer_profile_photo_link', lawyerProfilePhoto);
                        


                        formDataEmail.append('principalImage', formData.principalImage);
                        formDataEmail.append('secondPartyPrincipalImage', formData.secondPartyPrincipalImage);

                        formDataEmail.append('witnesses', JSON.stringify(formData.witnesses));


                        
                        // Send the PDF to the server via the API
                        const url = `${process.env.REACT_APP_API_URL}/transactions/upload_pdf/`;

                        updateData(url, formDataEmail, (responseData) => {

                          console.log("responseData",responseData);
                          if (responseData) {
                            setSuccessStatus(responseData.status);
                            handleReleaseCertificate();
                          }

                          setTimeout(() => {
                            setScale(previousScale.current);
                          }, 300);


                          setOpen(true);

                                                  
 

                        });
                      })
                    .catch((pdfError) => {
                      console.error('PDF generation failed:', pdfError);
                      setIsSubmitting(false); // ⛔ Still stop loading on error
                    });



                
                  } catch (error) {
                    console.error('Error generating or uploading PDF:', error);
                  }*/
            
          }
        });
    
   
  };



    const printableAcknowledgementForVirtual = useRef(null);

    const [print,setPrint] = useState(false);
    
    const printAcknowledgementPage = () => {

      console.log("printAcknowledgementPage",formData);
      setPrint(true);


      if(!formData.bookNo ||!formData.documentNo ||!formData.pageNo){
         setOpenOtherDetails(true);
        return;
      }

      
      if (printableAcknowledgementForVirtual.current) {
          console.log("formData",formData);
          const divContents = printableAcknowledgementForVirtual.current.innerHTML;
        const additionalStyles = `
          .bt_bp {
            border-top: 1px solid #28a745;
          }
  
          .text-times-new-roman {
            font-family: 'Times New Roman', Times, serif;
          }
        `;
        printContent(divContents, additionalStyles);
      } else {
        console.error("Ref is null, cannot access innerHTML");
      }
    };



  const [countdown, setCountdown] = useState(3);
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
       handleStartRecording();
    }
  }, [countdown]);
  

  const [isBlinking, setIsBlinking] = useState(false);
  const { localWebcamOn,localMicOn, enableWebcam, disableWebcam, leave, end, toggleMic, toggleWebcam } = useMeeting({
    onRecordingStateChanged: (data) => onRecordingStateChanged(data, setIsBlinking),
  });

  const { startRecording, stopRecording } = useMeeting();

  const [finalVideoUrl,setFinalVideoUrl] = useState("");
  const [finalVideoUrlWithExpiration,setFinalVideoUrlWithExpiration] = useState("");
  

    const handleStartRecording = async () => {
      console.log("arayko");
      // Configuration for recording
      const config = {
        layout: {
          type: "GRID",
          priority: "SPEAKER",
          gridSize: participantIds.length,
        },
        theme: "DARK",
        mode: "video-and-audio",
        quality: "high",
        orientation: "landscape",
      };
  
      // Configuration for post transcription
      let transcription = {
        enabled: true,
        summary: {
          enabled: true,
          prompt:
            "Write summary in sections like Title, Agenda, Speakers, Action Items, Outlines, Notes and Summary",
        },
      };
  
  
  
  
      const now = new Date();
      const year = now.getFullYear();
  
      // Array of month names with numeric prefixes
      const months = [
        "01-January",
        "02-February",
        "03-March",
        "04-April",
        "05-May",
        "06-June",
        "07-July",
        "08-August",
        "09-September",
        "10-October",
        "11-November",
        "12-December",
      ];
  
      const monthIndex = now.getMonth(); // 0-based index
      const month = months[monthIndex];
  
      const day = String(now.getDate()).padStart(2, '0');
      const timestamp = Date.now();
  
      // AWS S3 Directory Path with month name and numeric prefix
      const key = `recordings/${lawyerId}/${year}/${month}/${day}/${apitransactionid}_${timestamp}.mp4`;
      
      const awsDirPath = await createPresignedUrlWithClient(key);
  
       setFinalVideoUrl(awsDirPath.split("?")[0]);


       const command = new GetObjectCommand({
        Bucket: bucket,
        Key: key
      });

      try {
        const preSignedUrlForDownload = await getSignedUrl(s3Client, command, { expiresIn: expiresIn });
        setFinalVideoUrlWithExpiration(preSignedUrlForDownload);

  
      } catch (error) {
        console.error('Error generating pre-signed URL:', error);
      }



  
        // Prepare payload to send to your backend
        const payload = {
          roomId       : mid,
          token        : videoSDKToken,                                                                     // pass your VideoSDK token
          preSignedUrl : awsDirPath,
          awsDirPath   : key,
          config       : config,
          transcription: transcription,
          webhookUrl:"",
          templateUrl:""
          //webhookUrl   : "https://www.example.com/",
          //templateUrl  : `https://www.example.com/?token=token&meetingId=${mid}&participantId=RECORDER_ID`
        };
  
  
      // Start Recording
      const options = {
        method: "POST",
        headers: {
          Authorization: videoSDKToken,
          "Content-Type": "application/json",
        },
        data: {
          roomId: mid,
          preSignedUrl: awsDirPath
        },
        url: `https://api.videosdk.live/v2/recordings/start`,
      };
  
      try {
        //const response = await axios(options);
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/start-recording/`, payload,
          {
            headers: {
              "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
            },
          }
        );
        console.log("Recording started:", response.data);
        //const data = response.data;
        //console.log(data);
      } catch (error) {
        console.error("Error starting recording:", error);
      }
    };
  


  const handleStartRecording_old = async () => {
    // Configuration for recording
    const config = {
      layout: {
        type: "GRID",
        priority: "SPEAKER",
        gridSize: participantIds.length,
      },
      theme: "DARK",
      mode: "video-and-audio",
      quality: "high",
      orientation: "landscape",
    };

    // Configuration for post transcription
    let transcription = {
      enabled: true,
      summary: {
        enabled: true,
        prompt:
          "Write summary in sections like Title, Agenda, Speakers, Action Items, Outlines, Notes and Summary",
      },
    };




    const now = new Date();
    const year = now.getFullYear();

    // Array of month names with numeric prefixes
    const months = [
      "01-January",
      "02-February",
      "03-March",
      "04-April",
      "05-May",
      "06-June",
      "07-July",
      "08-August",
      "09-September",
      "10-October",
      "11-November",
      "12-December",
    ];

    const monthIndex = now.getMonth(); // 0-based index
    const month = months[monthIndex];

    const day = String(now.getDate()).padStart(2, '0');
    const timestamp = Date.now();

    // AWS S3 Directory Path with month name and numeric prefix
    const key = `recordings/${lawyerId}/${year}/${month}/${day}/${apitransactionid}_${timestamp}.mp4`;
    




     const awsDirPath = await createPresignedUrlWithClient(key);

     setFinalVideoUrl(awsDirPath.split("?")[0]);


    // Start Recording
    const options = {
      method: "POST",
      headers: {
        Authorization: videoSDKToken,
        "Content-Type": "application/json",
      },
      data: {
        roomId: mid,
        preSignedUrl: awsDirPath
      },
      url: `https://api.videosdk.live/v2/recordings/start`,
    };

    try {
      const response = await axios(options);
      const data = response.data;
      console.log(data);
    } catch (error) {
      console.error("Error starting recording:", error);
    }
  };

 
  

  
  const handleStopRecording = () => {
    stopRecording();
  };

    const handleEndMeeting = () => {
      Swal.fire({
          title: 'Before leaving, make sure you send the certificate.',
          text: 'Do you want to exit the page ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'btn btn-danger',
          cancelButtonColor: 'btn btn-secondary',
          confirmButtonText: 'Yes, exit!',
          cancelButtonText: 'No, cancel',
          confirmButtonColor: '#03c3ec',
          cancelButtonColor: '#ff3e1d',
        }).then((result) => {
          if (result.isConfirmed) {

          //window.location.href = '../../../oath';

          
           window.close();
           window.location.href = 'about:blank';

            
            
          }
        });
    }

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setScale(previousScale.current);
    setOpen(false);
  }


  const localStorageNotaryImage = localStorage.getItem('notary_image_'+id);
  const localStorageSecondParty = localStorage.getItem('second_party_image_'+id);
  const localStorageFirstParty  = localStorage.getItem('first_party_image_'+id);
  const localStorageWitnesses   = localStorage.getItem('witnesses_image_'+id);


  
  function transformTransactionDetails(details) {
    if (!details) return {};

    console.log("ssadasd",details);
    return {
      transactionId: details.transaction_id,
      scannedImages: details.images,
      witnesses: details.witnesses.map(witness => ({
        id: witness.id,
        contactInfo: witness.contact_info,
        dateCreated: witness.date_created,
        updatedBy: witness.updated_by,
        dateUpdated: witness.date_updated,
        participantType: witness.participant_type,
        participantProfilePhoto: witness.participant_profile_photo,
        participantSignaturePath: witness.participant_signature_path_base64,
        witnessFirstFullname: witness.participant_fullname,
        transaction: witness.transaction,
      })),
      transactionStatus: details.transaction_status,
      meetingId: details.meeting_id,
      meetingPass: details.meeting_pass,
      transactionPaymentStatus: details.transaction_payment_status,
      documentName: details.document_name,
      amount: details.document_price,
      documentAttachment: details.document_attachment,
      userLocation: details.user_location,
      documentForWhom: details.document_for_whom,
      documentToAddress: details.document_to_address,
      question1: details.question_1,
      question2: details.question_2,
      question3: details.question_3,
      question4: details.question_4,
      createdBy: details.created_by,
      dateCreated: details.date_created,
      dateUpdated: details.date_updated,
      updatedBy: details.updated_by,
      isSave: details.is_save,
      transactionType: details.transaction_type,
      releasedDocumentFile: details.released_document_file,
      referenceNo: details.reference_number,
      requestFor: details.request_for_other ?? "SELF",
      vehicleCategory: details.vehicle_category,
      vehicleType: details.vehicle_type,
      vehicle: details.vehicle,
      officialReceiptFile: details.official_receipt_file,
      certificateOfRegistrationFile: details.certificate_of_registration_file,
      principalImageSignature: details.signature_file_base64,
      firstName: details.first_name,
      middleName: details.middle_name,
      lastName: details.last_name,
      suffix: details.suffix,
      gender: details.gender,
      birthday: details.birth_date,
      contactNumber: details.contact_number,
      governmentId: details.attachment_id_file,
      idType: details.attachment_id_type,
      idNo: details.attachment_id_number,
      dateIssued: details.attachment_id_date_issued,
      principalImage: details.principal_image,
      region: details.region,
      province: details.province,
      cityMunicipality: details.city,
      barangay: details.barangay,
      residence: details.residence,
      dateReleased: details.date_released,
      forDraft: details.for_draft,
      insidePhilippines: details.is_inside_philippines,
      country: details.country,
      vehicleLicenseCategory: details.vehicle_license_category,
      professionalLicense: details.professional_license,
      userProfilePhoto: details.user_profile_photo,
      relationshipToBeneficiary: details.relationship,
      email: details.email,
      smsAttempts: details.sms_attempts,
      documentTitle: details.document_title,
      documentNo: details.document_no,
      pageNo: details.page_no,
      bookNo: details.book_no,
      secondPartyPrincipalImageSignature: details.second_party_signature_file_base64,
      secondPartyFirstName: details.second_party_first_name,
      secondPartyMiddleName: details.second_party_middle_name,
      secondPartyLastName: details.second_party_last_name,
      secondPartySuffix: details.second_party_suffix,
      secondPartyGender: details.second_party_gender,
      secondPartyBirthday: details.second_party_birth_date,
      secondPartyContactNumber: details.second_party_contact_number,
      secondPartyEmail: details.second_party_email,
      secondPartyGovernmentId: details.second_party_attachment_id_file,
      secondPartyIdType: details.second_party_attachment_id_type,
      secondPartyIdNo: details.second_party_attachment_id_number,
      secondPartyDateIssued: details.second_party_attachment_id_date_issued,
      secondPartyPrincipalImage: details.second_party_image,
      userProfile: details.user_profile,
      administrativeOfficer: details.administrative_officer,
      releasedBy: details.released_by,
    };
  }





  const { data: RefreshedTransactionDetailsInApi,errorMessage:errorRefreshedTransactionDetailsInApi,fetchData,isLoading } = useFetch();

  const handleClick = () => {
    fetchData(`${process.env.REACT_APP_API_URL}/transactions/${apitransactionid}/`);
  };

  useEffect(() => {
    if(RefreshedTransactionDetailsInApi){

  

        updateScale();


      const transformedData = transformTransactionDetails(RefreshedTransactionDetailsInApi);
      setFormData(transformedData);

          setFormData((prevFormData) => ({
            ...prevFormData,
            lawyerImage              : localStorageNotaryImage,
            principalImage           : localStorageFirstParty,
            secondPartyPrincipalImage: localStorageSecondParty,
            qr: RefreshedTransactionDetailsInApi.qr_code,

      }));
    }
  }, [RefreshedTransactionDetailsInApi]);




  const [openOtherDetails, setOpenOtherDetails] = useState(false);
  const handleCloseOtherDetails = () => {
    setOpenOtherDetails(false);
  }
  const handleSaveOtherDetails = () => {
    sendToEmail();
  }




    // UPDATE WITNESSES
  const { updateItem:updateItemWitnessTransaction, checkItemExists } = useModelData({
    model: "WitnessTransaction",
    queries: {
      list: listWitnessTransaction, // Assuming you have a query for listing
      update: updateWitnessTransaction,
    },
    subscriptions: {
      onUpdate: onUpdateWitnessTransaction,
    }
  });



  const client = generateClient();

  const triggerBulkUpdateByTransactionId = async () => {
  try {
    // Step 1: Query all WitnessTransaction items with this transaction_id
    const result = await client.graphql({
      query: listWitnessTransaction,
      variables: {
        filter: {
          transaction_id: { eq: apitransactionid }
        }
      }
    });

    const key = Object.keys(result.data)[0];
    const items = result.data[key]?.items || [];

    console.log("itemsListOfWitnesses",items);

    // Step 2: Loop through each item and update it (this can be a no-op or real update)
    await Promise.all(items.map(async (item) => {
      await updateItemWitnessTransaction({
        id: item.id,
        transaction_status:"RELEASED",
        updated_by:lawyerId
      });
    }));

    console.log(`Triggered update for ${items.length} items with transaction_id: ${apitransactionid}`);
  } catch (error) {
    console.error("Failed to trigger bulk update:", error);
  }
};



   const secondPartyRegId = localStorage.getItem('second_party_registration_id_'+id);
   const firstPartyRegId = localStorage.getItem('first_party_registration_id_'+id);


    const handleReleaseCertificate = async () => {
      const updateInput = {
        id                : id,
        transaction_status: "RELEASED",
      };
      await updateItem(updateInput);


      await sendPushNotification(firstPartyRegId, "", "ENOTARY", `Your Acknowledgement Certificate for transaction #${apitransactionid} has been released, it has been sent through email and is available in your app.`, "Certificate Released", "notification_user" );
      if(secondPartyRegId){
        await sendPushNotification(secondPartyRegId, "", "ENOTARY", `Your Acknowledgement Certificate for transaction #${apitransactionid} has been released, it has been sent through email and is available in your app.`, "Certificate Released", "notification_user" );
      }
    };
  

  const clearLocalStorageByPrefix = (prefixes) => {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (prefixes.some(prefix => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    }
  };

  const handleClear = () => {
    clearLocalStorageByPrefix(['first_party_', 'second_party_','notary_image_','witnesses_image_','notarialbook_cache','fetch_cache_']);
  };


 

  const handleEndTransaction = () => {
    triggerBulkUpdateByTransactionId();

    
    setTimeout(() => {
      handleClear();
      end();
      //window.location.href = '../../../oath';

      window.close();
      window.location.href = 'about:blank';
    }, 2000);


  }





  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [scale, setScale] = useState(1);
  const previousScale = useRef(1);

  
  
const updateScale = () => {
  if (!containerRef.current || !contentRef.current) return;

  const container = containerRef.current.getBoundingClientRect();
  const content = contentRef.current.getBoundingClientRect();

  const scaleX = container.width / content.width;
  const scaleY = container.height / content.height;

  const newScale = Math.min(scaleX, scaleY, 1);
  setScale(newScale);
  console.log("New Scale:", newScale);
};

useEffect(() => {
  // Run scale update after a short delay to allow layout/render to finish
  const timeout = setTimeout(() => {
    updateScale();
  }, 100); // 100ms delay to ensure DOM is ready

  // Add resize event listener
  window.addEventListener('resize', updateScale);

  return () => {
    clearTimeout(timeout);
    window.removeEventListener('resize', updateScale);
  };
}, [isLoading]);




console.log("errorMessageUpdate",errorMessageUpdate);
console.log("successMessageUpdate",successMessageUpdate);
console.log("responseDataUpdate",responseDataUpdate);
console.log("isLoadingUpdate",isLoadingUpdate);

console.log("errorRefreshedTransactionDetailsInApi",errorRefreshedTransactionDetailsInApi);
  return (
    <>
      <BackdropModalSmall open={openOtherDetails} handleClose={handleCloseOtherDetails} modalTitle="Fill-up other Details" >
        <div className="card-body shadow-xs">
          <div className="row mb-4">

           <h4>Before sending to email, make sure you input the right document no, page number and book number</h4>




            {successStatus === "success" && (
              <div className="d-flex mb-3 d-block d-md-none d-lg-none w-100 bg-success p-2 rounded flex-column">
                <span className="rounded w-100 text-center">
                  <i className="bx bx-check"></i> Certificate has been sent to email.
                </span>

                 {!transactionEnded && countdownClosing > 0 && (
                  <span className="text-center mt-2">
                    Closing in {countdownClosing}...
                  </span>
                )}
               
              </div>
            )}

            {errorMessageUpdate?.toLowerCase() === "transaction not found" &&
              <div className="d-flex mb-3 d-sm-block d-md-none d-lg-none w-100 bg-danger p-2 rounded">
                <span className=" rounded w-100 text-white"><i className="bx bx-x"></i>Not sent.Transaction not found.</span>
              </div>
            }
           

            <div className="col-md-4">
              <label className="form-label text-info" htmlFor="txtDocumentNo" >
                Document No.
              </label>
              <input
                type="text"
                className={`form-control mt-n1`}

                id="txtDocumentNo"
                value={formData.documentNo}
                name="document_no"
                placeholder="Enter Document No."
                aria-label="Document No"
                onChange={(e) => setFormData({ ...formData, documentNo: e.target.value })}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label text-info" htmlFor="txtPageNo" >
                Page No.
              </label>
              <input
                type="text"
                className={`form-control mt-n1`}
                id="txtPageNo"
                value={formData.pageNo}

                name="page_no"
                placeholder="Enter Page No."
                aria-label="Page No."
                onChange={(e) => setFormData({ ...formData, pageNo: e.target.value })}

              />
            </div>

            <div className="col-md-4">
              <label className="form-label text-info" htmlFor="txtBookNo" >
                Book No.
              </label>
              <input
                type="text"
                className={`form-control mt-n1`}

                id="txtBookNo"
                value={formData.bookNo}

                name="book_no"
                placeholder="Enter Book No"
                aria-label="Book No"
                onChange={(e) => setFormData({ ...formData, bookNo: e.target.value })}


              />
            </div>






          </div>
 

          <button className="btn btn-primary w-100 d-none" type="button"  onClick={() => { handleSaveOtherDetails(); }} >
                <><span className="" role="status" aria-hidden="true"></span>arayyko</>
          </button>

            {print ?

            <button className="btn btn-primary me-2" type="button" onClick={printAcknowledgementPage}>
              <span className="" role="status" aria-hidden="true"></span>Print
            </button>
            :
            successStatus === "success" ?
              <div className="d-flex flex-row">
                <button className="btn btn-primary me-2" type="button" onClick={() => handleEndTransaction()}>
                  <span className="" role="status" aria-hidden="true"></span>End Transaction
                </button>
                <span className="bg-success p-2 rounded w-200px d-none d-md-block d-lg-block"><i className="bx bx-check"></i>Certificate has been sent to email.</span> 
             
                {!transactionEnded && countdownClosing > 0 && (
                    <span className="text-center mt-2">
                      Closing in {countdownClosing}...
                    </span>
                  )}
             
              </div>
              :
              <button className="btn btn-primary w-100" type="button" disabled={isSubmitting} onClick={() => { handleSaveOtherDetails(); }} >
                {isSubmitting ?
                  <><span className="spinner-grow me-1" role="status" aria-hidden="true"></span>Generating PDF and Saving, Do not close...</>
                  :
                  <><span className="" role="status" aria-hidden="true"></span>Send To Email and Releaseed</>
                }
              </button>
          }

          
 
        

       


        </div>
      </BackdropModalSmall>



      {isLoading ?
        <LoadingAnimation text={"Fetching Latest Data & Generating PDF File ..."} />
        :
        <BackdropModal open={open} handleClose={handleClose} modalTitle="Generated PDFss" >


          {isSubmitting ?
            <LoadingAnimation text="Generating PDF..." />
          
            :

            <div ref={containerRef} style={{ width: '100%', height: '70vh', overflowY: 'scroll', overflowX: 'hidden', position: 'relative', }} >
              <div ref={contentRef} style={{ transform: `scale(${scale})`, transformOrigin: 'top left', width: '800px', height: '600px', padding: '0px', boxSizing: 'border-box', }} >
                <div ref={printableAcknowledgementForVirtual}>
                  <NotaryAcknowledgmentForVirtual isSubmitting={isSubmitting} formData={formData} dateReleased={new Date()} />
                </div>
              </div>
            </div>
          }






            {/* <button type='button' className="btn btn-primary me-2" onClick={printAcknowledgementPage}>Print Document</button> */}


            <div className="mt-3">

 
              {
                errorRefreshedTransactionDetailsInApi?.status===404 ?
                
                <div className="d-flex mb-3 alert alert-danger w-100 p-2 rounded">
                  <span className=" rounded w-100 text-center"><i className="bx bx-x"></i>Unable to send the certificate.Transaction not found.</span>
                </div>
                
                :

                <>
                  <button className="btn btn-primary  d-lg-block d-md-block d-none   me-2" type="button"
                    onClick={() => {
                      setOpenOtherDetails(true);
                      setPrint(false);
                    }}>
                    <span className="" role="status" aria-hidden="true"></span>Send To Email and Release1
                  </button>

                  <button className="btn btn-primary me-2 d-lg-none d-md-none d-block w-100" type="button"
                    onClick={() => {
                      setOpenOtherDetails(true);
                      setPrint(false);
                    }}>
                    <span className="" role="status" aria-hidden="true"></span>Send To Email and Release2
                  </button>
                </>
      }

      </div>

            


         
        </BackdropModal>
      }


      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container-xxl d-flex flex-wrap py-2 flex-row  justify-content-center" style={{zIndex:20000}}>
        <div className="btn-group    " role="group" aria-label="First group">
          <Tooltip title="Start Recording" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
            <button type="button" className={`btn btn-xl btn-outline-secondary p-2 p-sm-2 px-lg-5 px-md-4 py-lg-4 ${isBlinking ? "blinking" : ""}`} onClick={() => isBlinking ? handleStopRecording() : handleStartRecording()}>
              <i className={`tf-icons bx bxs-circle ${isBlinking ? "text-danger" : ""}`} style={{ fontSize: "xx-large" }}></i>
              {isBlinking && (<span className="fs-1 text-danger fw-bolder">REC</span>)}
            </button>
          </Tooltip>

          <Tooltip title="Toggle Mic" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
            <button type="button" className="btn btn-xl btn-outline-secondary p-2 p-sm-2 px-lg-5 px-md-4 py-lg-4" onClick={() => toggleMic()}><i className={`tf-icons bx ${localMicOn ? "bxs-microphone" : "bxs-microphone-off"}`} style={{ fontSize: "xx-large" }}></i></button>
          </Tooltip>

          <Tooltip title="Toggle Camera" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
            <button type="button" className="btn btn-xl btn-outline-secondary  p-2 p-sm-2 px-lg-5 px-md-4 py-lg-4" onClick={() => toggleWebcam()} ><i className={`tf-icons bx ${localWebcamOn ? "bxs-video" : "bxs-video-off"}`} style={{ fontSize: "xx-large" }}></i></button>
          </Tooltip>

          <Tooltip title="End Meeting" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
            <button type="button" className="btn btn-xl btn-danger  p-2 p-sm-2 px-lg-5 px-md-4 py-lg-4" onClick={() => handleEndMeeting()} ><i className="tf-icons bx bxs-phone text-white" style={{ fontSize: "xx-large", transform: "rotate(135deg)" }}></i></button>
          </Tooltip>
        </div>

        <Tooltip title="Generate PDF1" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
          <button type="button" className="btn btn-xl btn-outline-secondary  p-2 p-sm-2 px-lg-5 px-md-4 py-lg-4 rounded-3 ms-2" onClick={() => {
            setOpen(true);
            handleClick();
          }
          } ><i className="bx bxs-file-pdf text-white" style={{ fontSize: "xx-large" }}></i></button>
        </Tooltip>



        <div>
          {countdown > 0 && (
            <h2>Start Recording in {countdown}...</h2>
          )}
        </div>

      </div>

    </>
  );
}













function MeetingView({meetingId,transactionId,formData,setFormData,onMeetingLeave}) {
    const [joined, setJoined] = useState(null);
    const { join, participants } = useMeeting({
        //callback for when meeting is joined successfully
        onMeetingJoined: () => {
            setJoined("JOINED");
        },
          onMeetingLeft: () => {
          onMeetingLeave();
        },
    });
    const joinMeeting = () => {
        setJoined("JOINING");
        join();
    };

    useEffect(() => {
        const timer = setTimeout(() => {
          joinMeeting();
        }, 300);
        return () => clearTimeout(timer);
      }, []); 
 

    return (
      <div className="content-wrapper">
        {joined && joined === "JOINED" ? (
            <div className="d-flex flex-column  position-relative" style={{ height: "100vh" }}>
              <header className="bg-dark p-3 text-white d-none">
                <span className="fw-bold fs-5 blinking">
                  Please, record the meeting and send the generated certificate after oath taking.
                </span>
              </header>
               
              <div className="flex-fill d-flex justify-content-center align-items-center  ">
                <ParticipantGrid setFormData={setFormData} participantIds={[...participants.keys()]} transactionId={transactionId}  />
              </div>

              <footer className="content-footer footer    bg-dark position-fixed bottom-0 w-100" style={{zIndex:500}}>
                <Controls setFormData={setFormData}  formData={formData} participantIds={[...participants.keys()]}  />
              </footer>
            </div>         
        ) : joined && joined === "JOINING" ? (
          <LoadingAnimation text={"You are now joining the meeting..."} />
        ) : (
          <button className="d-none" onClick={joinMeeting}>
            Join the meeting
          </button>
        )}
      </div>
    );
}

const VideoCallNewWindowTest = () => {

  const [meetingId, setMeetingId] = useState(null);
  const [meetingConfig, setMeetingConfig] = useState(null);
  const [showMeeting, setShowMeeting] = useState(false)
     
  const { mid, id, apitransactionid } = useParams();
  const { user } = useAuth();
  const name ="ATTY. " + user.first_name?.toUpperCase() + " " + user.last_name?.toUpperCase()

  
  const [fetchErrorMessage, setFetchErrorMessage] = useState(null);
  const { transactionDetailsInApi, isLoading } = useCachedTransactions(apitransactionid, apiRequest, setFetchErrorMessage);
  const [formData, setFormData] = useState({});

 
  
  useEffect(() => {
  if (transactionDetailsInApi?.transaction_status?.toLowerCase() === "released") {
    Swal.fire({
      title: 'Already released',
      html: 'Transaction already released, you cannot rejoin the meeting.<br>Closing in <b></b> seconds.<br>',
      icon: 'warning',
      showConfirmButton: false,
      timer: 3000, // 3 seconds countdown
      didOpen: () => {
        const b = Swal.getHtmlContainer().querySelector('b');
        const timerInterval = setInterval(() => {
          const remaining = Math.ceil(Swal.getTimerLeft() / 1000);
          b.textContent = remaining;
        }, 100);
        Swal.getPopup().addEventListener('close', () => clearInterval(timerInterval));
      },
      willClose: () => {
      }
    }).then(() => {
      window.close();
      window.location.href = 'about:blank';
    });
  }
}, [transactionDetailsInApi]);




  useEffect(() => {
    if (fetchErrorMessage?.response?.data?.detail?.toLowerCase() === "not found") {
    Swal.fire({
      title: 'Not Found',
      html: 'Transaction not found.<br>Closing in <b></b> seconds.<br>',
      icon: 'warning',
      showConfirmButton: false,
      timer: 3000, // 3 seconds countdown
      didOpen: () => {
        const b = Swal.getHtmlContainer().querySelector('b');
        const timerInterval = setInterval(() => {
          const remaining = Math.ceil(Swal.getTimerLeft() / 1000);
          b.textContent = remaining;
        }, 100);

        Swal.getPopup().addEventListener('close', () => clearInterval(timerInterval));
      },
      willClose: () => {
      }
    }).then(() => {
      window.close();
      window.location.href = 'about:blank';
    });
  }
}, [fetchErrorMessage]);


 



  


  
  const getMeetingAndToken = async (id) => {
    const gen = id == null
      ? await createMeeting({ token: authToken })
      : id;
    setMeetingId(gen);

    // Immediately join with current pre-call settings
    setMeetingConfig({
      micEnabled: meetingConfig?.micEnabled,
      webcamEnabled: meetingConfig?.webcamEnabled,
      microphoneId: meetingConfig?.microphoneId,
      webcamId: meetingConfig?.webcamId,
    });
  };


  if (isLoading) {
    return <LoadingAnimation text="Fetching Transaction..." />;
  }
 
 

  return authToken && mid && meetingConfig && showMeeting ? (
      <MeetingProvider
        config={{

          meetingId: mid,

          ...meetingConfig,


          // micEnabled: true,
          // webcamEnabled: true,

          name: name,
          // participantId: "xyz",
          permissions: {
            // askToJoin: true,
            // toggleParticipantWebcam: true,
            // removeParticipant: true,
            endMeeting: true,
          },
          metaData: {
            userId            : user.user_id,
            firstname         : user.first_name,
            lastname          : user.last_name,
            middlename        : user.middle_name,
            email             : user.email,
            contact           : user.mobile_number,
            user_type         : user.user_type,
            user_profile_photo: user?.user_profile_photo,
            registrationId    : user?.registrationId,
            transactionId     : user?.transactionId,
            documentName      : user?.documentName,
          }
        }}
        token={authToken}>
        <MeetingView meetingId={mid} transactionId={id} formData={formData} setFormData={setFormData} onMeetingLeave={() => { setMeetingId(null); setMeetingConfig(null); }}  />
      </MeetingProvider>
  )
       :
      (
         <PreCallSetup
            meetingId={mid}
            getMeetingAndToken={getMeetingAndToken}
            onStartMeeting={(cfg) => {
              setMeetingConfig(cfg);
              setShowMeeting(true);
            }}
          />
      )
  ;
}

export default VideoCallNewWindowTest;